exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".indicated[data-v-35e6d1b2]{white-space:pre-line}.smaller[data-v-35e6d1b2]{font-size:75%}.main-title[data-v-35e6d1b2]{font-weight:500;margin-bottom:0}.indicated-title[data-v-35e6d1b2]{font-size:75%;font-weight:500;margin-bottom:0}.promotional[data-v-35e6d1b2]{text-decoration:line-through;text-decoration-color:#ed1763;margin:0;color:#777}.product-price[data-v-35e6d1b2]{color:#000;font-size:16px;font-weight:400;margin-bottom:0;font-family:Montserrat}.offer-box[data-v-35e6d1b2]{height:100%}.description[data-v-35e6d1b2]{height:60%;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35e6d1b2","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/store/components/OfferContent.vue
// module id = SpMp
// module chunks = 102